<template>
    <div>
        <!-- 系统列表 -->
        <a-table id="myServiceTable" :columns="columns" :data-source="tableData" 
            :pagination="false" :loading="tloading" rowKey="id" >
            <template slot="operation" slot-scope="text, record">
                <router-link class="tableLink" :to="{path:'detail_passwaytype',query: {id: record.id,}}">详情</router-link>
                <router-link class="tableLink"  :to="{path:'edit_passwaytype',query: {id: record.id,}}">编辑</router-link>
                <a-popconfirm title="确认删除?" @confirm="() => handleDelete(record)">
                    <a class="tableLink"  href="javascript:;">删除</a>
                </a-popconfirm>
            </template>
            
            
        </a-table>

        <a-pagination style="float:right;margin-top:20px;" v-model="pagination.page" :pageSize="pagination.pageSize"
            :total="pagination.total" @change="handlePageChange" show-less-items show-quick-jumper />

    </div>
</template>
<script>
let pagination ={
    page:1,
    pageSize:10,
    total:0
};

const columns = [

    {
        title: "通道类型编码",
        dataIndex: "passwaytype",
        scopedSlots: { customRender: 'platforms' },
        align: "center",
        width:120
    },
    {
        title: "通道类型名称",
        dataIndex: "passwaytypename",
        scopedSlots: { customRender: 'status' },
        align: "center",
        width:100
    },

    {
        title: '操作',
        dataIndex: 'operation',
        align: 'center',
        width: 150,
        scopedSlots: { customRender: 'operation' },
    }

];

export default {
    data() {
        return {
            columns,
            tableData:[],
            tloading:false,
            pagination,
            clientWidth:800,
            searchP:{},
        };
    },
    methods: {

        handlePageChange(v){
            this.pagination.page = v
            this.getAppSumData();
        },
        handleDelete(item){
            let that = this;
            that.$store.dispatch({
                type: "mcmsmanager/deleteMcmsPasswaytypes",
                params: {id: item.id}
            }).then((res) => {
                if (res.status == '200') {
                    that.pagination.page = 1;
                    that.getAppSumData()
                }
            });
            
        },
        getAppSumData(){
            let that = this
            let params = {
                ...that.searchP,
                ...that.pagination,
                urlparams:false
            };
            that.$store.dispatch({
                type: "mcmsmanager/selectMcmsPasswaytypesPage",
                params:params
            }).then((res)=>{
                if(res.status == 200 && res.data.success == '1'){
                    let result = res.data.data;
                    this.tableData = result.list;
                    this.pagination.total = parseInt(result.totalRecords);
                    this.pagination.pageSize = parseInt(result.pageSize);
                    this.pagination.page = parseInt(result.page);
                }
                that.tloading = false;
            }).catch(() => {
                that.tloading = false;

            });
        },
        handleSearch(searchP){
            this.searchP = searchP;
            this.pagination.page = 1;
            this.getAppSumData();
        },

    },

    components:{
        
    },
    mounted(){
    }
};
</script>
<style scoped>
    .trend_pagination{
        margin-top: 10px;
    }

    .tableLink{
        margin-right: 10px;
    }

</style>

